import React from 'react';
import { Modal as AntdModal } from 'antd';
import { Button } from '../Button';

// Wrap the AntD Modal to provide default footer buttons
export const Modal = (props) => {
    const {
        footer,
        okText,
        cancelText,
        onOk,
        onCancel,
        okButtonProps,
        cancelButtonProps,
        maskClosable = false,
        confirmLoading = false,
        ...restProps
    } = props;

    if (footer !== undefined) {
        return <AntdModal footer={footer} maskClosable={maskClosable} {...props} />;
    }

    const defaultFooter = (
        <>
            <Button onClick={onCancel} {...cancelButtonProps}>
                {cancelText || 'Cancel'}
            </Button>
            <Button type="primary" onClick={onOk} loading={confirmLoading} {...okButtonProps}>
                {okText || 'OK'}
            </Button>
        </>
    );

    return (
        <AntdModal {...restProps} maskClosable={maskClosable} footer={defaultFooter} onOk={onOk} onCancel={onCancel} />
    );
};
